module.exports = __webpack_public_path__ + "static/media/hamburger-menu-mobile.c5860f1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hamburger-menu-mobile.svg
// module id = 170
// module chunks = 0